import { AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { Button } from "@/components/ui/button";

const CHECK_NAMES = {
  1: "Dates in the wrong year", 2: "Uncategorised rows", 4: "Wrong category type", 5: "Text in an amount cell", 6: "Possible typos",
  10: "Bank feed double-ups",
};

const Issue = ({ issue, onFix, busyKey, readOnly }) => (
  <div className="border-b border-border last:border-0 px-5 py-4 flex flex-col md:flex-row md:items-center gap-3" data-testid={`dq-issue-${issue.key}`}>
    <div className="flex-1 min-w-0">
      <div className="font-mono text-[11px] text-muted-foreground">{issue.ref}</div>
      <div className="text-sm mt-0.5">{issue.detail}</div>
    </div>
    {!readOnly && (
      <div className="flex flex-wrap gap-2 shrink-0">
        {issue.fixes.map((f, i) => (
          <Button key={i} size="sm" variant={f.action === "dismiss" ? "ghost" : i === 0 ? "default" : "outline"} disabled={busyKey === issue.key}
            onClick={() => onFix(issue, i)} data-testid={`dq-fix-${issue.key}-${i}`}>{f.label}</Button>
        ))}
      </div>
    )}
  </div>
);

export default function IssueList({ checks, onFix, busyKey, readOnly = false }) {
  const groups = Object.keys(CHECK_NAMES).map((c) => [c, checks.issues.filter((i) => String(i.check) === c)]);
  return (
    <div className="space-y-6" data-testid="dq-issue-list">
      {groups.map(([c, list]) => (
        <section key={c} className="border border-border bg-card" data-testid={`dq-check-${c}`}>
          <div className="px-5 py-3 border-b border-border flex items-center gap-2">
            {list.length ? <AlertTriangle className="h-4 w-4 text-amber-400" /> : <CheckCircle2 className="h-4 w-4 text-emerald-400" />}
            <span className="font-display font-semibold">{c}. {CHECK_NAMES[c]}</span>
            <span className="ml-auto font-mono text-xs text-muted-foreground" data-testid={`dq-count-${c}`}>{list.length ? `${list.length} to do` : "All clear"}</span>
          </div>
          {list.map((i) => <Issue key={i.key} issue={i} onFix={onFix} busyKey={busyKey} readOnly={readOnly} />)}
        </section>
      ))}
      <section className="grid gap-3 md:grid-cols-2">
        {checks.info.map((i) => (
          <div key={i.check} className="border border-border bg-card p-4 text-sm flex gap-3" data-testid={`dq-info-${i.check}`}>
            <Info className="h-4 w-4 text-emerald-400 shrink-0 mt-0.5" />
            <div><div className="font-semibold">{i.check}. {i.title}</div><div className="text-muted-foreground mt-1">{i.detail}</div></div>
          </div>
        ))}
      </section>
    </div>
  );
}
